import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VCard,
    { attrs: { flat: "" } },
    [
      _c(VCardTitle, { staticClass: "subtitle-1 primary--text" }, [
        _vm._v(" " + _vm._s(_vm.titulo) + " "),
      ]),
      _c(
        VCardText,
        [
          _c(
            VRow,
            { attrs: { dense: "" } },
            [
              _c(
                VCol,
                [
                  _c(
                    VMenu,
                    {
                      attrs: {
                        "close-on-content-click": false,
                        "nudge-width": 500,
                        "offset-y": "",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "activator",
                          fn: function ({ on: onMenu }) {
                            return [
                              _c(
                                VTooltip,
                                {
                                  attrs: { top: "" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function ({ on: onTooltip }) {
                                          return [
                                            _c(
                                              VBtn,
                                              _vm._g(
                                                {
                                                  attrs: {
                                                    color: "primary",
                                                    text: "",
                                                    disabled:
                                                      _vm.cursosInstrutorDoTipo
                                                        .length >= _vm.maximo,
                                                  },
                                                  on: { click: _vm.toogleForm },
                                                },
                                                { ...onTooltip, ...onMenu }
                                              ),
                                              [
                                                _vm._v(" Adicionar "),
                                                _c(
                                                  VIcon,
                                                  { staticClass: "ml-2" },
                                                  [_vm._v(" add_circle ")]
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                },
                                [
                                  _c("span", [
                                    _vm._v("Clique para adicionar um curso"),
                                  ]),
                                ]
                              ),
                            ]
                          },
                        },
                      ]),
                      model: {
                        value: _vm.dialog,
                        callback: function ($$v) {
                          _vm.dialog = $$v
                        },
                        expression: "dialog",
                      },
                    },
                    [
                      _c(
                        VCard,
                        { staticClass: "pa-5" },
                        [
                          _c(VCardTitle, [
                            _c(
                              "h5",
                              {
                                staticClass:
                                  "headline primary--text text-no-wrap",
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.isEdicao ? "Edição" : "Cadastro"
                                    ) +
                                    " de Curso "
                                ),
                              ]
                            ),
                          ]),
                          _c(VCardSubtitle, [
                            _vm._v("Informe os dados do curso"),
                          ]),
                          _c(
                            VCardText,
                            [
                              _c(
                                VForm,
                                {
                                  ref: "form",
                                  on: {
                                    submit: function ($event) {
                                      $event.preventDefault()
                                      return _vm.save.apply(null, arguments)
                                    },
                                  },
                                  model: {
                                    value: _vm.valid,
                                    callback: function ($$v) {
                                      _vm.valid = $$v
                                    },
                                    expression: "valid",
                                  },
                                },
                                [
                                  _c(
                                    VRow,
                                    [
                                      _c(VTextField, {
                                        attrs: { label: "Nome do curso" },
                                        model: {
                                          value: _vm.curso.nome,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.curso,
                                              "nome",
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                            )
                                          },
                                          expression: "curso.nome",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            VCardActions,
                            [
                              _c(
                                VRow,
                                { staticClass: "justify-end mr-4" },
                                [
                                  _c(
                                    VBtn,
                                    {
                                      staticClass: "mr-2",
                                      attrs: {
                                        disabled: _vm.curso.nome.trim() === "",
                                        color: "primary",
                                      },
                                      on: { click: _vm.save },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.isEdicao
                                              ? "Editar"
                                              : "Cadastrar"
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                  _c(
                                    VBtn,
                                    {
                                      attrs: { color: "primary", outlined: "" },
                                      on: { click: _vm.toogleForm },
                                    },
                                    [_vm._v(" Cancelar ")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._l(_vm.cursosInstrutorDoTipo, function (c) {
                    return _c(
                      VChip,
                      {
                        key: c.id,
                        staticClass: "ml-2",
                        attrs: {
                          color: "secondary",
                          "text-color": "white",
                          close: "",
                        },
                        on: {
                          "click:close": function ($event) {
                            return _vm.remove(c)
                          },
                        },
                      },
                      [_vm._v(" " + _vm._s(c.nome) + " ")]
                    )
                  }),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }